import { featureCards } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择91影视
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            四大核心优势，给你最好的追剧看片体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {featureCards.map((card) => (
            <div
              key={card.id}
              className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center group hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg mx-auto mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-3">{card.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}